import { render, staticRenderFns } from "./CouponIssued.vue?vue&type=template&id=47047ab3&scoped=true"
import script from "./CouponIssued.vue?vue&type=script&lang=js"
export * from "./CouponIssued.vue?vue&type=script&lang=js"
import style0 from "./CouponIssued.vue?vue&type=style&index=0&id=47047ab3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47047ab3",
  null
  
)

export default component.exports